import appCaptainFinance from "../../views/appPlans/captainFinance.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "captainplans";
  const params = ["page", "limit"];

  $stateProvider.state("captainfinance", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCaptainFinance,
      },
    },
    reloadOnSearch: false,
    data: { title: "Captain Finance" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainFinance/captainFinance.urls.js